import useLoginCallback from './useLoginCallback';

const LoginCallback = () => {
  const { } = useLoginCallback();
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div className="loginCallBackScreenLoadingDiv"></div>
    </div>
  );
};

export default LoginCallback;
